export const getPatientToggleVariant = ({ isActive, isDark }) => {
  if (isActive) {
    return 'primary'
  }

  return isDark ? 'dark' : 'light'
}

export default getPatientToggleVariant
